import { Component } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { slideInAnimation } from './route-animation';
import { animations } from './animations';
import { SPINNER, POSITION } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { MyMessageService } from './services/my-message.service';

import * as _ from 'lodash';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [slideInAnimation, animations],
})
export class AppComponent {
  SPINNER = SPINNER;
  POSITION = POSITION;

  constructor(
    private _router: Router,
    private _myMessageService: MyMessageService
  ) {
    // updates the google analytics page fetching
    if (environment.production) {
      this._router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'UA-170120648-1', {
            // eslint-disable-next-line camelcase
            page_path: event.urlAfterRedirects,
          });
        }
      });
    }

    if (environment.hmr) {
      const modalBackDropElem = document.querySelector('div.modal-backdrop');

      console.clear();
      if (modalBackDropElem) {
        modalBackDropElem.remove();
      }
      this._myMessageService.raiseMessage(
        _.sample(['error', 'warn', 'success']),
        'Updated'
      );
    }
  }
}
